import React from 'react';
import './style.css';

const GeoProgressBar = ({ in_progress=false }) => {
  return <>
    { in_progress ? <div className="pgb_wrapper">
      <div className="progressbar"></div>
    </div> : null }
  </>
};

export default GeoProgressBar;